export default {
  PRODUCT_SHELVES_TIME_FORMAT: 'DD天HH:mm:ss'
};
